import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  uid: string
  email: string
}

interface AuthState {
  user: User | null
  token: string | null
  isLoading: boolean
  setUser: (user: User | null) => void
  setToken: (token: string | null) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoading: true,
      setUser: (user) => set({ user }),
      setToken: (token) => {
        set({ token })
        if (token) {
          localStorage.setItem('beat-auth-token', token)
        } else {
          localStorage.removeItem('beat-auth-token')
        }
      },
      logout: () => {
        set({ user: null, token: null })
        localStorage.removeItem('beat-auth-token')
      },
    }),
    {
      name: 'beat-auth',
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
)

export function useAuth() {
  const { user, token, setUser, setToken, logout } = useAuthStore()
  
  const isAuthenticated = !!token
  const isLoading = !token && !user
  
  const login = async (firebaseToken: string) => {
    setToken(firebaseToken)
  }
  
  const register = async (firebaseToken: string) => {
    setToken(firebaseToken)
  }
  
  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    setUser,
  }
}
